module.exports = __webpack_public_path__ + "img/specimen.84e85862.svg";